{
  "de": {
    "baseBtn": {
      "labels": {
        "loading": "Bitte warten..."
      },
      "confirm": {
        "question": "Sicher?",
        "yes": "Ja",
        "no": "Nein"
      }
    }
  }
}
